"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const Resource_1 = __importDefault(require("../../Resource"));
const EFinanceDurableGroups_1 = require("../../../enums/Scpi/PhysicalPerson/Groups/EFinanceDurableGroups");
const class_validator_1 = require("class-validator");
const ESubPartInvestissementsDurables_1 = require("../../../enums/Scpi/PhysicalPerson/FinanceDurable/ESubPartInvestissementsDurables");
const ESubPreferenceDurabilite_1 = require("../../../enums/Scpi/PhysicalPerson/FinanceDurable/ESubPreferenceDurabilite");
class GenericFinanceDurableRequestResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.category = "finance_durable";
    }
}
exports.default = GenericFinanceDurableRequestResource;
__decorate([
    (0, class_validator_1.IsBoolean)({ groups: [EFinanceDurableGroups_1.EFinanceDurableGroups.familierInvestissementResponsable] }),
    (0, class_transformer_1.Expose)({ groups: [EFinanceDurableGroups_1.EFinanceDurableGroups.familierInvestissementResponsable] }),
    __metadata("design:type", Boolean)
], GenericFinanceDurableRequestResource.prototype, "familierInvestissementResponsable", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)({ groups: [EFinanceDurableGroups_1.EFinanceDurableGroups.importanceEngagementsEnvironnementaux] }),
    (0, class_transformer_1.Expose)({ groups: [EFinanceDurableGroups_1.EFinanceDurableGroups.importanceEngagementsEnvironnementaux] }),
    __metadata("design:type", Boolean)
], GenericFinanceDurableRequestResource.prototype, "importanceEngagementsEnvironnementaux", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ESubPartInvestissementsDurables_1.ESubPartInvestissementsDurables, { groups: [EFinanceDurableGroups_1.EFinanceDurableGroups.partInvestissementsDurables] }),
    (0, class_transformer_1.Expose)({ groups: [EFinanceDurableGroups_1.EFinanceDurableGroups.partInvestissementsDurables] }),
    __metadata("design:type", String)
], GenericFinanceDurableRequestResource.prototype, "partInvestissementsDurables", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)({ groups: [EFinanceDurableGroups_1.EFinanceDurableGroups.durabiliteCriterePrimordial] }),
    (0, class_transformer_1.Expose)({ groups: [EFinanceDurableGroups_1.EFinanceDurableGroups.durabiliteCriterePrimordial] }),
    __metadata("design:type", Boolean)
], GenericFinanceDurableRequestResource.prototype, "durabiliteCriterePrimordial", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((o) => o.durabiliteCriterePrimordial === true, {
        groups: [EFinanceDurableGroups_1.EFinanceDurableGroups.preferenceDurabilite],
    }),
    (0, class_validator_1.IsEnum)(ESubPreferenceDurabilite_1.ESubPreferenceDurabilite, { groups: [EFinanceDurableGroups_1.EFinanceDurableGroups.preferenceDurabilite] }),
    (0, class_transformer_1.Expose)({ groups: [EFinanceDurableGroups_1.EFinanceDurableGroups.preferenceDurabilite] }),
    __metadata("design:type", String)
], GenericFinanceDurableRequestResource.prototype, "preferenceDurabilite", void 0);
